import EventDispatcher from './EventDispatcher';

export default EventDispatcher;
export * from './constants';
